// Mobile fallback: ensure FILTER button always opens slideout drawer.
// Also wires up the accordion + price slider/sliderfill behaviour for the
// mobile filter drawer.
(function () {
  if (window.__mobileFilterDrawerFallbackBound) return;
  window.__mobileFilterDrawerFallbackBound = true;

  var applyFilterDrawerOffset = function (drawer) {
    if (!drawer || window.innerWidth >= 1024) return;
    var header = document.querySelector('.section-header__main-bar') || document.querySelector('.section-header');
    var announcement = document.querySelector('.js-site-announcement-bar');
    if (!announcement) {
      announcement = document.querySelector('.section-top-bar__wrapper');
    }
    var headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    var announcementHeight = 0;
    if (announcement) {
      var annStyles = window.getComputedStyle(announcement);
      if (annStyles.display !== 'none' && annStyles.visibility !== 'hidden') {
        announcementHeight = Math.ceil(announcement.getBoundingClientRect().height);
      }
    }
    var topOffset = headerHeight + announcementHeight;
    drawer.style.top = topOffset + 'px';
    drawer.style.height = 'calc(100vh - ' + topOffset + 'px)';
    drawer.style.zIndex = '10001';
  };

  window.addEventListener('resize', function () {
    var openedDrawer = document.querySelector('.slideout[data-wau-slideout="collection-filters"].is-open, .slideout[data-wau-slideout="collection-filters"].active');
    applyFilterDrawerOffset(openedDrawer);
  });

  var initMobileFilterAccordion = function (drawer) {
    if (!drawer || window.innerWidth >= 1024 || drawer.dataset.mobileAccordionBound === 'true') return;
    var filterMenu = drawer.querySelector('.js-mobile-menu[data-menu-handle="filter"]');
    if (!filterMenu) return;

    drawer.dataset.mobileAccordionBound = 'true';
    var secondLevelWrappers = filterMenu.querySelectorAll('.slide-nav__second-level--wrapper');
    var triggerButtons = filterMenu.querySelectorAll('.slide-nav__first-level--button[data-link-trigger]');

    secondLevelWrappers.forEach(function (panel) {
      panel.classList.remove('is-open-accordion');
    });
    triggerButtons.forEach(function (btn) {
      btn.classList.remove('is-open-accordion');
    });

    triggerButtons.forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        var trigger = btn.getAttribute('data-link-trigger');
        if (!trigger) return;
        var panel = filterMenu.querySelector('.slide-nav__second-level--wrapper[data-link-parent="' + trigger + '"]');
        if (!panel) return;
        var firstLevelItem = btn.closest('.slide-nav__first-level--item');

        var willOpen = !panel.classList.contains('is-open-accordion');
        secondLevelWrappers.forEach(function (item) { item.classList.remove('is-open-accordion'); });
        triggerButtons.forEach(function (item) { item.classList.remove('is-open-accordion'); });

        if (willOpen) {
          if (firstLevelItem && firstLevelItem.parentNode) {
            firstLevelItem.parentNode.insertBefore(panel, firstLevelItem.nextSibling);
          }
          panel.classList.add('is-open-accordion');
          btn.classList.add('is-open-accordion');
        }
      }, true);
    });

    if (filterMenu.dataset.priceAutoApplyBound !== 'true') {
      filterMenu.dataset.priceAutoApplyBound = 'true';
      var priceAutoApplyTimer;
      var triggerPriceApply = function () {
        clearTimeout(priceAutoApplyTimer);
        priceAutoApplyTimer = setTimeout(function () {
          var applyBtn = filterMenu.querySelector('.slide-nav__second-level--wrapper[data-link-parent="price"] .js-update-price');
          if (applyBtn) applyBtn.click();
        }, 220);
      };
      filterMenu.addEventListener('change', function (ev) {
        var target = ev.target;
        if (!target || !target.closest) return;
        if (target.closest('.slide-nav__second-level--wrapper[data-link-parent="price"]')) {
          if (target.matches('input[type="range"], input[type="number"]')) {
            triggerPriceApply();
          }
        }
      }, true);
    }

    if (filterMenu.dataset.priceSyncBound !== 'true') {
      filterMenu.dataset.priceSyncBound = 'true';
      var updatePriceSliderFill = function (pricePanel) {
        if (!pricePanel) return;
        var ranges = pricePanel.querySelectorAll('.filter-range__slider--input');
        var wrapper = pricePanel.querySelector('.filter-range__slider--wrapper');
        if (ranges.length < 2 || !wrapper) return;
        var minRange = ranges[0];
        var maxRange = ranges[1];
        var floor = parseFloat(minRange.min || 0);
        var ceil = parseFloat(minRange.max || 100);
        if (!isFinite(ceil) || ceil <= floor) ceil = floor + 1;
        var minValue = parseFloat(minRange.value || floor);
        var maxValue = parseFloat(maxRange.value || ceil);
        var minPct = ((minValue - floor) / (ceil - floor)) * 100;
        var maxPct = ((maxValue - floor) / (ceil - floor)) * 100;
        minPct = Math.max(0, Math.min(100, minPct));
        maxPct = Math.max(0, Math.min(100, maxPct));
        wrapper.style.setProperty('--price-min-pct', minPct + '%');
        wrapper.style.setProperty('--price-max-pct', maxPct + '%');
      };

      filterMenu.addEventListener('input', function (ev) {
        var target = ev.target;
        if (!target || !target.matches || !target.matches('input[type="range"]')) return;
        var pricePanel = target.closest('.slide-nav__second-level--wrapper[data-link-parent="price"]');
        if (!pricePanel) return;
        var ranges = pricePanel.querySelectorAll('.filter-range__slider--input');
        var fields = pricePanel.querySelectorAll('.js-filter-range-input');
        if (ranges.length < 2 || fields.length < 2) return;
        var min = Math.round(parseFloat(ranges[0].value) || 0);
        var max = Math.round(parseFloat(ranges[1].value) || 0);
        fields[0].value = min;
        fields[1].value = max;
        updatePriceSliderFill(pricePanel);
      }, true);

      var initPricePanel = filterMenu.querySelector('.slide-nav__second-level--wrapper[data-link-parent="price"]');
      if (initPricePanel) {
        updatePriceSliderFill(initPricePanel);
        var initRanges = initPricePanel.querySelectorAll('.filter-range__slider--input');
        initRanges.forEach(function (rangeInput) {
          var sync = function () { updatePriceSliderFill(initPricePanel); };
          rangeInput.addEventListener('input', sync, { passive: true });
          rangeInput.addEventListener('change', sync, { passive: true });
          var bringToFront = function () {
            initRanges.forEach(function (item) { item.style.zIndex = '2'; });
            rangeInput.style.zIndex = '3';
          };
          rangeInput.addEventListener('pointerdown', bringToFront, { passive: true });
          rangeInput.addEventListener('touchstart', bringToFront, { passive: true });
          rangeInput.addEventListener('mousedown', bringToFront);
        });
      }
    }
  };

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('.js-filter-toggle.js-slideout-open')
      : null;
    if (!trigger || window.innerWidth >= 1024) return;

    event.preventDefault();
    event.stopPropagation();

    if (window.WAU && window.WAU.Slideout) {
      window.WAU.Slideout.init('collection-filters');
      if (typeof window.WAU.Slideout._openByName === 'function') {
        window.WAU.Slideout._openByName('collection-filters');
      }
    }

    var drawer = document.querySelector('.slideout[data-wau-slideout="collection-filters"]');
    var overlay = document.querySelector('.slideout__overlay');
    if (drawer) {
      drawer.classList.add('is-open', 'active');
      drawer.style.transform = 'translateX(0)';
      applyFilterDrawerOffset(drawer);

      var menuButtons = drawer.querySelectorAll('.filter-drawer__menu-toggle .js-menu-toggle');
      var mobileMenus = drawer.querySelectorAll('.filter-drawer__mobile-menus .js-mobile-menu');
      menuButtons.forEach(function (btn) {
        btn.classList.toggle('active--menu', btn.getAttribute('data-toggle-menu') === 'filter');
        if (btn.getAttribute('data-toggle-menu') === 'filter') {
          btn.textContent = 'Filter';
        }
      });
      mobileMenus.forEach(function (menu) {
        var isFilter = menu.getAttribute('data-menu-handle') === 'filter';
        menu.classList.toggle('active--menu', isFilter);
        // Snippet emits inline style="display: none;" when product count >=1000.
        // We must clear it after toggling active--menu, otherwise the filter
        // block stays hidden even with the active class.
        if (isFilter) {
          menu.style.removeProperty('display');
        }
        var firstLevels = menu.querySelectorAll('.slide-nav__first-level--wrapper');
        firstLevels.forEach(function (wrapper) {
          wrapper.classList.toggle('nav-slide--active', isFilter);
        });
      });
      initMobileFilterAccordion(drawer);
    }
    if (overlay) {
      overlay.style.display = 'block';
      overlay.style.opacity = '1';
      overlay.style.visibility = 'visible';
      overlay.style.zIndex = '10000';
    }
  }, true);
})();
